import React from 'react';
import { Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import {
  removeSelectedPlantId,
  selectSelectedPlantsDuringAdvice,
  setSelectedPlantIds,
} from '../../../../ducks/plants';
import { plantFiltersAdvice } from '../../../../utils/filters';
import FilterableList from '../../../../components/FilterableList';
import { plantSelectionTypesEnum } from '../../../../ducks/plants/types';
import {
  getAdvice,
  getFloweringArch,
} from '../../../../ducks/floweringArch';
import { floweringArchTypesEnum } from '../../../../ducks/floweringArch/types';
import SubjectCard from '../../../../components/SubjectCard';
import {
  booleanText, parseCopyRightText,
  parseTrueFalseNullText,
} from '../../../../utils/valuesToHumanReadable';
import {
  helpTextPlantPresentAccordingToModel,
  helpTextPlantPresentAccordingToUser,
} from '../../../../utils/text';

const SelectedPlants = () => {
  const dispatch = useDispatch();
  const selectedPlants = useSelector(selectSelectedPlantsDuringAdvice);

  if (selectedPlants.length === 0) {
    return (
      <Row className="mt-4 justify-content-center d-flex">
        <span>Nog geen planten geselecteerd</span>
      </Row>
    );
  }

  return (
    <FilterableList
      filterConfig={plantFiltersAdvice}
      data={selectedPlants}
      searchableByProperties={['dutchName', 'scientificName']}
      quickSelect={{
        handleDeselectAll: () => {
          dispatch(setSelectedPlantIds({
            selectionType: plantSelectionTypesEnum.pickedFromAdviceIds,
            plantIds: [],
          }));
          dispatch(getAdvice());
          dispatch(getFloweringArch(floweringArchTypesEnum.basedOnAdvise));
        },
        selectedCount: selectedPlants.length,
      }}
      render={(filteredData) => filteredData.map((plant) => (
        <SubjectCard
          key={plant.id}
          md={6}
          lg={4}
          title={plant.dutchName}
          subtitle={plant.scientificName}
          imagePath={plant.imagePath}
          copyrightText={parseCopyRightText(plant)}
          propertiesToList={[
            {
              key: 'Als reeds aanwezig aangeduid',
              help: helpTextPlantPresentAccordingToUser,
              value: parseTrueFalseNullText(plant.isPresentAccordingToUser),
            },
            {
              key: 'Gemodelleerd in jouw gebied',
              help: helpTextPlantPresentAccordingToModel,
              value: booleanText(plant.isPresentAccordingToModel),
            },
          ]}
          ranges={plant.floweringMonths}
          rangesHeading="Bloeitijd"
          handleClick={() => {
            dispatch(removeSelectedPlantId({
              selectionType: plantSelectionTypesEnum.pickedFromAdviceIds,
              plantId: plant.id,
            }));
            dispatch(getAdvice());
            dispatch(getFloweringArch(floweringArchTypesEnum.basedOnAdvise));
          }}
          isSelected
        />
      ))}
    />
  );
};

export default SelectedPlants;
